import React from 'react';
import { Button } from './ui/button';
import { Code2, Rocket, Mail } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-slate-200">
          <Code2 className="w-4 h-4 text-blue-600" />
          <span className="text-sm font-medium text-slate-700">Web Development Agency</span>
        </div>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 leading-tight">
          Building Powerful Websites
          <br />
          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            at Affordable Prices
          </span>
        </h1>

        <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-3xl mx-auto">
          Angular | React | Python Web Solutions
        </p>

        <p className="text-lg text-slate-500 mb-12 max-w-2xl mx-auto">
          Professional web development services for startups, small businesses, and individuals.
          Fast, responsive, and scalable solutions tailored to your needs.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            onClick={() => scrollToSection('contact')}
          >
            <Mail className="w-5 h-5 mr-2" />
            Get a Free Quote
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            className="border-2 border-slate-300 hover:border-blue-600 hover:bg-blue-50 px-8 py-6 text-lg rounded-xl transition-all duration-300 hover:scale-105"
            onClick={() => scrollToSection('services')}
          >
            <Rocket className="w-5 h-5 mr-2" />
            View Services
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-slate-600">
          <div className="text-center">
            <div className="text-3xl font-bold text-slate-900">50+</div>
            <div className="text-sm">Projects Completed</div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-slate-900">98%</div>
            <div className="text-sm">Client Satisfaction</div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-slate-900">Fast</div>
            <div className="text-sm">Delivery Time</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;